import { render } from "./store-form.vue?vue&type=template&id=615aef3b&scoped=true&ts=true"
import script from "./store-form.vue?vue&type=script&lang=tsx"
export * from "./store-form.vue?vue&type=script&lang=tsx"

import "./store-form.vue?vue&type=style&index=0&id=615aef3b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615aef3b"]])

export default __exports__